<template>
  <div class="container">
    <div class="header">
      <i class="iconfont icon-fanhui-" @click="_tobackPage"></i>
      文章详情
    </div>
    <div class="body">
      <div class="title">{{ detailData.a_title }}</div>
      <div class="data">{{ detailData.a_release_time }}</div>
      <div class="content" v-html="detailData.a_content"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import http from '@/util/http'

export default {
  data() {
    return {
      detailData: {}
    }
  },
  mounted() {
    this._getDetail()
  },
  methods: {
    _renderDom() {
      const imgEle = document.getElementsByTagName('img')
      const windowsWidth = window.innerWidth
      for (let i = 0; i < imgEle.length; i++) {
        imgEle[i].style.width = windowsWidth * 0.7 + 'px'
        imgEle[i].style.maxWidth = windowsWidth * 0.7 + 'px'
        imgEle[i].style.height = 'auto'
        imgEle[i].style.objectFit = 'fill'
      }
    },
    _tobackPage() {
      this.$router.go(-1)
    },
    _getDetail() {
      const targetId = this.$route.query.id
      http.get('selDetailWeb/' + targetId).then(res => {
        console.log(res)
        if (res.code == 200) {
          this.detailData = res.data
          // setTimeout(() => {
          //   this._renderDom()
          // }, 1000)
          this.$nextTick(() => {
            this._renderDom()
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.header {
  width: 100%;
  height: 70px;
  background-color: #1242fc;
  color: #fff;
  font-size: 18px;
  line-height: 70px;
  text-align: center;
}

.header i {
  float: left;
  margin-left: 10px;
}

.body {
  width: 100%;
  height: 85%;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  overflow: hidden;
  overflow-y: scroll;
  margin-top: 15px;
}

.body .title {
  width: 360px;
  min-height: 90px;
  /* background-color: pink; */
  /* line-height: 70px; */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  font-size: 20px;
  font-weight: 500;
}

.body .data {
  width: 80%;
  height: 40px;
  font-size: 12px;
  /* background: skyblue; */
  color: #cacaca;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.body .content {
  width: 80%;
  /* height: 80%; */
  /* background-color: #7db180; */
}

.content p {
  text-indent: 2em;
}
</style>
